import type { IEntityModel } from './base/entity_model'
import type { IParticipant } from './participant'

export enum ParticipantAuditTrailAction {
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
}

export interface IParticipantAuditTrail extends IEntityModel {
  participantId: string
  action: ParticipantAuditTrailAction
  before?: Partial<IParticipant> // changed fields before the action, should exist if action is Update
  after?: Partial<IParticipant> // changed fields after the action, should exist if action is Update
  projectId: string
  identityId: string
}
